import React from "react";
import styles from "./CardGameType.module.css";
import { AllCardsGames } from "../util/AllCardsGames";
import { useNavigate } from "react-router-dom";
import RedirectCircleView from "./RedirectCircleView";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import IndicatorVideoImage from "./IndicatorVideoImage";
import { ButtonSize, ButtonType, JokerButton } from "material-ui-jokerpro";
import AssetsPack from "../util/AssetsPack";
import { getResponsiveBgImage } from "../util/ExtensionFunction";

interface CardGameTypeProps {
  title: string;
  paragraph: string;
  URL: string | (() => void);
  srcImage: string[];
  indicatorVideo?: string;
  isHoveredIndex: boolean;
  isLearnEnable?: boolean;
  type?: AllCardsGames;
}

const CardGameType: React.FC<CardGameTypeProps> = ({
  title,
  paragraph,
  srcImage,
  indicatorVideo,
  isHoveredIndex,
  type = null,
  isLearnEnable = true,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <div
      className={`${styles["card-gametype-container"]} ${
        isHoveredIndex && styles["card-gametype-container-hover"]
      }`}
      style={{ backgroundImage: `url(${getResponsiveBgImage(srcImage)})` }}
    >
      <div className={styles["card-gametype-inner"]}>
        {!isLearnEnable && (
          <div className={styles.watch_video}>
            {t("global_component.game_info")}
          </div>
        )}

        {indicatorVideo && (
          <div
            className={clsx(
              styles["card-gametype-video-icon"],
              isHoveredIndex && styles["hidden"]
            )}
          >
            <IndicatorVideoImage
              indicatorUrl={indicatorVideo}
              gameType={type}
            />
          </div>
        )}

        <div className={styles["card-gametype-text-container"]}>
          <div className={styles["card-gametype-text-holder"]}>
            <div>
              <div className={styles["card-gametype-title"]}>{title}</div>
              <div
                className={clsx(
                  styles["card-gametype-description"],
                  !isLearnEnable && styles["full-width"]
                )}
              >
                {paragraph}
              </div>
            </div>
            {isLearnEnable && (
              <div className={styles["card-gametype-bottom-description"]}>
                <div className={styles["card-redirect"]}>
                  <RedirectCircleView
                    onClick={() => navigate(`/learn?scrollTo=${type}`)}
                    className={styles["redirect"]}
                    isHovered={isHoveredIndex}
                  />

                  <div className={styles["button"]}>
                    <JokerButton
                      text={t("global_component.view_game")}
                      type={ButtonType.CTA}
                      size={ButtonSize.Medium}
                      onClick={() => navigate(`/learn?scrollTo=${type}`)}
                      icon={AssetsPack.icons.ICON_GO.default}
                      isFullWidth
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardGameType;
